import { CoursesViewUser } from 'components/courses';

const HomeActiveCourses = () => (
  <CoursesViewUser
    isHomeView={true}
    limitPerPage={4}
    showAllLinkHref="/courses?type=active"
    titleShowCount={false}
  />
);

export default HomeActiveCourses;
